/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from '../../utility/paypalAphrodite';
import * as AppActions from '../../actions/AppActions';
import AppStore from '../../stores/AppStore';
import AppDispatcher from '../../dispatcher/AppDispatcher';
import TemplateData, { localsMessages } from '../../utility/getTemplateData';
import { isLTR as isLeftToRight } from '../../utility/helper';
import { loadBodyMovin } from '../../utility/lazyLoader';
import { formatAmount } from '../../utility/formator';
import { sanitizeOrgName } from '../../utility/domUtils';
import RecurringInfo from './RecurringInfo';
import { Checkbox, Tooltip, Modal } from '@paypalcorp/pp-react';
import { preventFormSubmitOnTooltipClick } from '../../utility/fixPpReactToolTip';
import { trackLinkClick } from '../../fpti/fpti';
import { FEATURES, FPTI_TAGS, LINK_NAME } from '../../fpti/fptiConstants';
import { Row, Col } from '@paypalcorp/pp-react';
import { addFeature } from '../../fpti/helper';

const orgname = TemplateData.donationName ? TemplateData.donationName : '';
const isLTR = isLeftToRight();
let texts = localsMessages('common/recurring-checkbox');
let isContinue = false;

const styles = StyleSheet.create({
  wrapper: {},
  centered: {
    display: 'flex',
    justifyContent: 'center',
  },
  toolWrapper: {
    display: 'inline-block',
    position: 'relative',
    margin: '0',
    paddingBottom: '10px',
  },
  animationWrapper: {
    width: '100%',
    position: 'absolute',
    height: 125,
    marginTop: -125,
  },
  animationContainer: {
    transform: isLTR ? 'scaleX(1)' : 'scaleX(-1)',
    height: 250,
    width: 250,
    marginLeft: -35,
  },
  recurringButton: {
    width: '100%',
    padding: 20,
    borderRadius: '3rem',
    fontSize: 15,
    marginBottom: 0,
  },
  borderOnly: {
    background: 'transparent',
    color: '#0070ba',
  },
  divider: {
    position: 'relative',
    borderBottom: '1px solid #ccc',
    textAlign: 'center',
    margin: '0 0 20px',
  },
  dividerContent: {
    position: 'relative',
    textAlign: 'center',
    backgroundColor: '#fff',
    display: 'inline-block',
    margin: 0,
    top: 9,
    padding: '0 10px',
    fontSize: 18,
  },
  verticalCentered: {
    display: 'flex',
    alignItems: 'center',
  },
});

class RecurringCheckBox extends React.Component {
  constructor(props) {
    super(props);
    const amount = AppStore.getDonationAmount() || '';
    const currency = AppStore.getDonationCode() || '';
    this.state = {
      showhelp: this.props.status,
      formatedAmount: formatAmount({ currency: currency, value: amount }),
    };
  }

  componentDidMount = () => {
    this.dispatcherToken = AppDispatcher.register((payload) => {
      if (payload.action && payload.action.actionType === 'CHANGE_AMOUNT') {
        const { action: { item: { amount = 0 } = {} } = {} } = payload;
        this.updateAmount(amount);
      }
    });

    preventFormSubmitOnTooltipClick();

    addFeature(FEATURES.RECURRING);
  };

  componentWillUnmount = () => {
    isContinue = this.props.continue;
    AppDispatcher.unregister(this.dispatcherToken);
  };

  loadAnimation(display) {
    if (!display) {
      return;
    }
    loadBodyMovin().then(() => {
      // Animation is displayed after bodymovin files are downloaded
      // On slow connections, user may click the checkbox a few times before
      // the JS files are downloaded
      if (this.state.isAnimating) {
        return;
      }
      const animationData = window.heartsAnimationData;
      const bodymovinLibrary = window.bodymovin;
      if (!bodymovinLibrary || !animationData) {
        return;
      }
      this.setState({
        isAnimating: true,
      });

      bodymovinLibrary.loadAnimation({
        // eslint-disable-line
        container: document.getElementById('animationContainer'),
        renderer: 'svg',
        loop: 1,
        autoplay: true,
        animationData,
      });
      // Destroying with timeout
      setTimeout(() => {
        bodymovinLibrary.destroy(); // eslint-disable-line
        this.setState({
          isAnimating: false,
        });
      }, 1000);
    });
  }

  updateAmount = (value) => {
    const currency = AppStore.getDonationCode() || '';
    this.setState({ formatedAmount: formatAmount({ currency, value }) });
  };

  handleChange = (ev) => {
    let { showhelp } = this.state;
    let isChecked = ev.target.checked;
    let chkBxStatus = isChecked ? 'checked' : 'unchecked';

    this.loadAnimation(isChecked);

    AppActions.changeRecurring({
      recurring: chkBxStatus,
    });
    trackLinkClick(LINK_NAME.RECURRING_CHECKBOX, {
      additionalData: {
        [FPTI_TAGS.CHECKBOX]: chkBxStatus,
      },
    });

    this.props.handleChange(isChecked);

    this.setState({ showhelp: (showhelp = !showhelp) });
  };

  createMarkup = (content) => {
    return { __html: content };
  };

  render() {
    let { recurring_label, perMonth } = texts.rp;

    const checked = { checked: false };
    if (this.props.status) {
      checked.checked = true;
    }

    return (
      <Row>
        <div
          className="checkbox-bottom-margin "
          id="recurringCheckboxContainer"
        >
          <Col>
            <div className="padding-0">
              {isContinue ? (
                <div>
                  <span>{perMonth}</span>
                </div>
              ) : (
                <div>
                  <div className={css(styles.toolWrapper)}>
                    <div
                      className={css(styles.animationWrapper)}
                      id="animationWrapper"
                      style={{
                        display: this.state.isAnimating ? 'block' : 'none',
                      }}
                    >
                      <div
                        className={css(styles.animationContainer)}
                        id="animationContainer"
                      ></div>
                    </div>
                    <div className={css(styles.verticalCentered)}>
                      <Checkbox
                        className="inline-block"
                        label={recurring_label}
                        name="recurringCheckbox"
                        id="recurringCheckbox"
                        onChange={this.handleChange}
                        value={this.props.status}
                        {...checked}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Col>
          {this.props.status && !isContinue && (
            <Col>
              <RecurringInfo
                orgName={sanitizeOrgName(orgname)}
                amount={this.state.formatedAmount}
              />
            </Col>
          )}
        </div>
      </Row>
    );
  }
}

RecurringCheckBox.propTypes = {
  handleChange: PropTypes.func,
  status: PropTypes.bool,
  continue: PropTypes.bool,
};

RecurringCheckBox.defaultProps = {
  handleChange: () => {},
};

export default RecurringCheckBox;
